import { render } from "./notification-queue.vue?vue&type=template&id=a9c3ceb6&lang=html"
import script from "./notification-queue.vue?vue&type=script&lang=js"
export * from "./notification-queue.vue?vue&type=script&lang=js"

import "./notification-queue.vue?vue&type=style&index=0&id=a9c3ceb6&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__